import RecordRTC from 'recordrtc'
import * as Tone from 'tone'
import { ref } from 'vue'

let recorder
export function useRecorder(filename) {
  const audioBlob = ref(null)
  const audioFile = ref(null)

  const getMicAccess = () => {
    return new Promise((resolve, reject) => {
      if (recorder != null) {
        recorder.destroy()
      }
      navigator.mediaDevices
        .getUserMedia({
          audio: {
            autoGainControl: false,
            echoCancellation: false,
            noiseSuppression: false,
          },
        })
        .then((stream) => {
          recorder = RecordRTC(stream, {
            type: 'audio',
            recorderType: RecordRTC.StereoAudioRecorder,
            mimeType: 'audio/mp3',
            numberOfAudioChannels: 1,
          })
          resolve()
        })
        .catch(() => {
          reject()
        })
    })
  }

  const startRecorder = () => {
    getMicAccess().then(() => {
      recorder.startRecording()
      startMeter()
    })
  }

  const stopRecorder = () => {
    return new Promise((resolve) => {
      recorder.stopRecording(() => {
        stopMeter()

        audioBlob.value = recorder.getBlob()

        audioFile.value = new File(
          [audioBlob.value],
          filename + '.mp3' || 'recording.mp3',
          { type: 'audio/mp3' }
        )

        resolve(audioFile.value)
      })
    })
  }

  // --- Meter ---
  const meter = new Tone.Meter()
  const volume = ref(null)
  let intervalId = null

  const startMeter = () => {
    const mic = new Tone.UserMedia()
    meter.normalRange = true
    meter.smoothing = 0.5
    mic.open()
    mic.connect(meter)
    intervalId = setInterval(() => {
      volume.value = meter.getValue() * 300
    }, 25)
  }

  const stopMeter = () => {
    clearInterval(intervalId)
  }

  return { getMicAccess, startRecorder, stopRecorder, volume, audioBlob, audioFile }
}
